















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyChart from '@/views/GSurveyAnalyze/GSurveyChart.vue';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import GLoading from '@/components/GLoading.vue';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { SurveyAnalysisTabelMapping } from '@/models/jgrow/survey-analysis-tabel-mapping';
import GOptionalData from '@/components/GOptionalData.vue';
import { MetaAwarenessGrowthQuestion } from '@/models/jgrow/survey-answer';
import { Activity } from '@/models/activity/activity';

@Component({
  name: 'GSurveySelectActivityAnalyze',
  components: {
    GLoading,
    GSurveyChart,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GOptionalData,
    GStatisticsBoxplotSubTableInfoTable,
  },
  computed: {},
  methods: {},
})
export default class GSurveySelectActivityAnalyze extends mixins(GPageBase) {
  columns: any[] = []; // テーブル形式のテーブルカラム情報
  surveyAnalysisTabelMap: Map<number, SurveyAnalysisTabelMapping> = new Map();
  surveyAnalysisTabels: SurveyAnalysisTabelMapping[] = [];

  @Prop() competencyID: number;

  async mounted() {
    this.columns = [
      {
        title: 'アクティビティ',
        key: 'title',
        width: 300,
        align: 'center',
        slot: 'title',
      },
      {
        title: '人数',
        key: 'count',
        width: 50,
        align: 'center',
        slot: 'count',
      },
    ];

    const rateTables: Map<number, Map<number, SurveyAnalysisTabelMapping>> = await surveyAnalyzeModule.getActivitySelectAnswerTabels();
    this.surveyAnalysisTabelMap = rateTables.get(this.competencyID);
    this.surveyAnalysisTabels = [...this.surveyAnalysisTabelMap.values()];
  }

  get activities(): Activity[] {
    return surveyAnalyzeModule.activities;
  }

  getActivityName(id: number): string {
    return surveyAnalyzeModule.activityNameMap.get(id);
  }
}
